import gate from '@/api/axios';

/**
 * Получает список промокодов
 * @async
 * @function promocodesGet
 * @param {Object} payload
 * @returns {Promise}
 */
export const promocodesGet = async (payload) => gate.get('/promoCodes', payload);

/**
 * Создает промокод
 * @async
 * @function promocodesCreatePromocode
 * @param {Object} payload
 * @returns {Promise}
 */
export const promocodesCreatePromocode = async (payload) => gate.post('/promoCodes', payload);

/**
 * Деактивирует промокод
 * @async
 * @function promocodesDeactivatePromocode
 * @param {Object} payload
 * @returns {Promise}
 */
export const promocodesDeactivatePromocode = async (payload) => gate.post(`/promoCodes/${payload.id}/deactivate`, payload);
